module.exports = __webpack_public_path__ + "img/racecourse-icon.bcea9487.svg";